import { Text } from "@mantine/core";

export default function HeaderTitle({ children, testId }: { children: string; testId?: string }) {
  return (
    <Text size="sm" fw={600} truncate maw="50vw" data-testid={testId}>
      {children}
    </Text>
  );
}
